import { Button, ButtonTheme } from '@apply/components';

interface FileSelectFooterProps {
    id: string;
    onCancel: () => void;
    onContinue: () => void;
    /** Continue stays disabled until at least one usable file is picked. */
    canContinue: boolean;
}

/** Cancel on the left, Continue on the right. */
export const FileSelectFooter = ({ id, onCancel, onContinue, canContinue }: FileSelectFooterProps) => {
    return (
        <>
            <Button
                id={`${id}_cancel`}
                theme={ButtonTheme.LinkBlue}
                handleClick={onCancel}
            >
                Cancel
            </Button>
            <Button
                id={`${id}_continue`}
                handleClick={onContinue}
                width='120px'
                disabled={!canContinue}
            >
                Continue
            </Button>
        </>
    );
};
